import { connect } from "react-redux";
import withHOC from "../../HOC/HOC";
import { bindActionCreators } from "redux";
import React from "react";
import References from "./References";
import { loanUpdateAction, setReferencesValuesAction } from "../CreateLoan/CreateLoanAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import { Row } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
class ReferencesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            toShowToast: false,
            successToastMessage: "",
            level: "",
        }
    }

    scrollToTop = () => {
        window.scrollTo(0, 0);
      };    

    callAPI = (references, callback) => {
        this.scrollToTop();
        this.props.setReferencesValuesAction(references)
        const requestData = {
            minimartId: this.props.singleMiniMart.id,
            loanApplicationId: this.props.applyLoanConfig.loanApplicationId,
            additionalInfo: references
        };
        this.props.showLoadingModal();
        loanUpdateAction(requestData, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.setState({
                    toShowToast: true,
                    successToastMessage: Strings("loanFormUpdatedSuccessfully"),
                    level: "success",
                },()=>{
                    setTimeout(() => {
                        this.props.closeLoadingModal();
                        this.props.handleNext();
                        callback("");
                    }, 1000); 
                });
            } else {
                this.props.closeLoadingModal();
                callback(response.error.message);
            }
            
        })
    }
    render() {
        return (
            <Row>
                {this.state.toShowToast && (
                    <UserNotification
                        key={this.state.successToastMessage}
                        userNotificationObj={{
                            message: this.state.successToastMessage,
                            level: this.state.level,
                        }}
                    />
                )}

                <References
                    callAPI={this.callAPI}
                    referencesDetails={this.props.referencesDetails}
                    loanApplicationDetails={this.props.loanApplicationDetails}
                    goNext={this.props.handleNext}
                    goBack={this.props.handleBack}
                    additionalInfo={this.props.additionalInfo}
                    disableTextField={this.props.disableTextField}
                    errorMessage={this.state.errorMessage}
                    showLoadingModalState={this.props.showLoadingModalState}
                    scrollToTop={this.scrollToTop}
                />
            </Row>
        )
    }
}
const mapStateToProps = (state) => ({
    singleMiniMart: state.minimartListReducer.singleMiniMart,
    loanApplicationId: state.loanDetailsReducer.loanApplicationId,
    allLoanDetails: state.loanDetailsReducer.allLoanDetails,
    referencesDetails: state.loanDetailsReducer.referencesDetails,
    additionalInfo: state.loanDetailsReducer.additionalInfo,
    applyLoanConfig: state.loanDetailsReducer.applyLoanConfig,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        { setReferencesValuesAction },
        dispatch
    );
};
const ReferencesContainerContainerWrapper = withHOC(ReferencesContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReferencesContainerContainerWrapper);